import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "./page/Login/login";
import App from "./App";
import ProtectedRoute from "./routers/protectedRoute";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "./api/config";

const AppRoutes = () => {
  const msalInstance = getMsalInstance();

  if (!msalInstance) {
    return (
      <Switch>
        <Route path="/" component={Login} />
      </Switch>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Switch>
        <Route path="/Login" component={Login} />
        <ProtectedRoute path="/" component={App} />
      </Switch>
    </MsalProvider>
  );
};

export default AppRoutes;
